import { defineComponent as _defineComponent } from 'vue';
import { computed } from 'vue';
import { DropdownMenuPortal, DropdownMenuSubContent, useForwardPropsEmits } from 'reka-ui';
import { cn } from '../utils';
export default /*@__PURE__*/ _defineComponent({
    ...{ inheritAttrs: false },
    __name: 'MenuSubContent',
    props: {
        forceMount: { type: Boolean, required: false },
        loop: { type: Boolean, required: false },
        memoDependencies: { type: Array, required: false },
        sideOffset: { type: Number, required: false, default: 4 },
        sideFlip: { type: Boolean, required: false },
        alignOffset: { type: Number, required: false },
        alignFlip: { type: Boolean, required: false },
        avoidCollisions: { type: Boolean, required: false },
        collisionBoundary: { type: null, required: false },
        collisionPadding: { type: [Number, Object], required: false },
        arrowPadding: { type: Number, required: false },
        hideShiftedArrow: { type: Boolean, required: false },
        sticky: { type: String, required: false },
        hideWhenDetached: { type: Boolean, required: false },
        positionStrategy: { type: String, required: false },
        updatePositionStrategy: { type: String, required: false },
        disableUpdateOnLayoutShift: { type: Boolean, required: false },
        prioritizePosition: { type: Boolean, required: false },
        reference: { type: null, required: false },
        asChild: { type: Boolean, required: false },
        as: { type: null, required: false },
        class: { type: [Boolean, null, String, Object, Array], required: false, skipCheck: true }
    },
    emits: ["escapeKeyDown", "pointerDownOutside", "focusOutside", "interactOutside", "entryFocus", "openAutoFocus", "closeAutoFocus"],
    setup(__props, { expose: __expose, emit: __emit }) {
        __expose();
        const props = __props;
        const emits = __emit;
        const delegated = computed(() => {
            const { class: _ignored, ...rest } = props;
            return rest;
        });
        const forwarded = useForwardPropsEmits(delegated, emits);
        const __returned__ = { props, emits, delegated, forwarded, get DropdownMenuPortal() { return DropdownMenuPortal; }, get DropdownMenuSubContent() { return DropdownMenuSubContent; }, get cn() { return cn; } };
        Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true });
        return __returned__;
    }
});
